var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ding-login-container"},[_c('div',{staticClass:"ding-login-content"},[_c('h1',{staticClass:"ding-login-title"},[_vm._v("钉钉扫码激活雪亮工程处理工具")]),_c('div',{staticClass:"self-defined-classname",attrs:{"id":"self_defined_element"}}),_c('div',{staticClass:"ding-login-tips"},[_vm._v("请使用钉钉App扫码登录")])])])
}]

export { render, staticRenderFns }